<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">When will I receive payment?</h1>

			<p v-if="buyer === 'ValoreBooks'">
				Congratulations on selling a book in our instant-bid buyback program! The buyer of the book is one of our used book partners and is anxiously
				awaiting receiving it. Once received they will review the book to ensure it meets the condition you listed it in, and then will send us a
				notification if accepted. If rejected, they will return the book to you after reaching out via email. Keep in mind, this process can take a
				little longer, on average it's between 14-30 days to be confirmed from the date you ship.
			</p>

			<p>
				<span v-if="payment_date" v-html="payment_date"></span>
				If you haven't received your payment in time, please write us using the form below.
			</p>

			<email-form
					caption="Email Us"
					subject="I have not received payment for this order"
					:body="email_body"
					on-success-url="/help?#/submitted"
					edit-body
					must-edit
					:payload="{order_line_id: order_line_id, has_attachment: true}"
					destination-key="cs"
			></email-form>
		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';
	import EmailForm from './../components/EmailForm';
	import _ from 'lodash';
	import moment from 'moment';
	import Axios from 'axios';

	export default {
		name: "WhenWillReceivePayment",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				order_id: null,
				order_line_id: parseInt(this.$route.params.item_id) || 0,
				payment_date: null,
				item_id: null,
				isbn: null,
				buyer: null,
			};
		},

		methods: {
			nth(date) {
				return date.replace(/(\d+)(st|nd|rd|th)/g, '$1<sup>$2</sup>');
			}
		},

		mounted() {
			const self = this;
			self.loading = true;

			_.defer(function () {
				self.$eventHub.$emit('show-loader', true);
			});

			Axios.get('/service/customer_help/rest/index.php/customer_help/get_sales_orders/?order_line_id=' + this.order_line_id)
				.then(function (response) {
					if (response.status === 200 && response.data && response.data['status'] === 'success') {
						let d = response['data']['data'];
						if (d.length > 0) {
							d = d[0];
							self.isbn = d['isbn'];
							self.order_id = d['order_id'];
							self.item_id = d['item_id'];
							self.buyer = d['buyer_username'];
						}
					}
				})
				.finally(function () {
					self.loading = false;
					self.$eventHub.$emit('hide-loader');
				});

			Axios.get('/service/customer_help/rest/index.php/customer_help/get_payment_receive_date/' +
				this.order_line_id
			).then(response => {
				if (response.data.status === 'success' && (response = response.data.data)) {
					const due = moment(response, 'YYYY-MM-DD HH:mm:ss');
					const pay = due.clone().endOf('day');

					if (due.date() < 7) {
						pay.set('date', 7);
					} else if (due.date() < 22) {
						pay.set('date', 22);
					} else {
						pay.set('date', 7).add(1, 'month');
					}

					if (pay < moment()) {
						this.payment_date = `We have sent you a payment on this date: ${pay.format('MM-DD-YYYY')}.<br>`;
					} else {
						this.payment_date = `The payment is due on the ${this.nth(due.format('Do of MMMM'))} and you will be paid on the next payment cycle on the <strong>${this.nth(pay.format('Do of MMMM'))}</strong>.`;
					}
				} else {
					this.payment_date = this.nth('Payments will be issued on the closest 7th or 22nd.<br>');
				}
			});
		},

		computed: {
			email_body() {
				return `I have not received payment for this order, can you advise when I will receive payment?\nMy tracking number is: `;
			}
		}
	}
</script>

<style scoped>

</style>